import React from 'react';

import { BusinessCard } from 'consumer-page-widgets/BusinessCard';
import { Grid } from 'ui';
import { Theme, css } from '@emotion/react';

export interface Region {
  region: string; // Name of the region, e.g. "Napa"
  state: string; // state or territory of the region, e.g. "California"
  img: string; // URL of image to show for the region
  href: string; // Destination for clicks on the region
}

export interface Props {
  region: Region; // the region to render
}

const regionCard = ({ colors }: Theme) => css`
  background-color: ${colors.bgDefault};
`;

const RegionGridItem: React.FC<Props> = ({ region }) => {
  return (
    <Grid item xs={12} sm={4} data-testid="featured-region">
      <BusinessCard
        altText={`Image of ${region.region}`}
        css={regionCard}
        title={region.region}
        titleProps={{
          component: 'p',
          variant: 'body01Strong',
        }}
        subtitle={region.state}
        subtitleProps={{
          variant: 'overline',
          component: 'p',
        }}
        href={region.href}
        dominantColor="#e9e9eb" // dummy color, not worth anything fancier
        image={region.img}
      />
    </Grid>
  );
};

export default RegionGridItem;
